import * as React from "react";
import { UitkCardAlohaPlaceholder } from "uitk-react-cards";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import { GridPlaceholderProps } from "./typings";
import { UitkLayoutGrid } from "uitk-react-layout-grid";

export const GridPlaceholder = (gridPlaceholderProps: GridPlaceholderProps) => {
  const keyHelper = new ItemKeyHelper(`${gridPlaceholderProps.flexTemplateNodeId}-placeholder-Grid`);

  return (
    <div className="Deals all-b-margin-three">
      <div className="all-t-margin-four">
        <UitkCardAlohaPlaceholder className="all-l-margin-three placeholder-header" />
        <UitkCardAlohaPlaceholder className="all-l-margin-three all-t-margin-two placeholder-subheader" />
        <UitkLayoutGrid
          columns={{ medium: 2, extra_large: 3, small: 1 }}
          space="three"
          className="all-l-margin-three all-r-margin-three all-t-margin-three"
        >
          {[...Array(12)].map((val, index) => (
            <div key={keyHelper.next()}>
              <UitkCardAlohaPlaceholder className="placeholder-card" />
            </div>
          ))}
        </UitkLayoutGrid>
      </div>
    </div>
  );
};
